// import { useState } from 'react'
import { Label } from '~/components/UI/shadcn/label'
import { Switch } from '~/components/UI/shadcn/switch'

// import { useQuery } from '@tanstack/react-query'
// import { getFilters } from '~/components/Content/Filters/data'
import { parseAsBoolean, useQueryState } from 'nuqs'

type SwitchInput = {
  disabled: true | false
  checked?: true | false
  bgColour: 'light-blue' | 'mid-blue' | undefined | null
  label: string
  opposite?: string
  switch?: boolean
  queryKey?: string
}

const FormUISwitch = (props: SwitchInput) => {
  const { disabled, bgColour, label, opposite, checked } = props
  // const [isChecked, setIsChecked] = useState(checked)
  const labelId = label.toLowerCase().replace(' ', '-')

  const [isChecked, setIsChecked] = useQueryState<boolean>(
    props.queryKey || 'filters',
    parseAsBoolean.withDefault(checked ?? false)
  )

  return (
    <div className='space-x-xs flex items-center'>
      <Switch
        id={labelId}
        disabled={disabled || false}
        bgColour={bgColour}
        className='group'
        aria-label={label}
        checked={isChecked}
        onCheckedChange={value => setIsChecked(value)}
      />
      <Label
        htmlFor={labelId}
        className='text-base-sm peer-disabled:text-grey-m cursor-pointer peer-hover:underline peer-disabled:no-underline peer-disabled:opacity-100 hover:underline'
      >
        {isChecked ? (opposite ? opposite : label) : label}
      </Label>
    </div>
  )
}

export default FormUISwitch
